import { render } from "./coupon.vue?vue&type=template&id=a11b3f48&scoped=true"
import script from "./coupon.vue?vue&type=script&lang=js"
export * from "./coupon.vue?vue&type=script&lang=js"

import "./coupon.vue?vue&type=style&index=0&id=a11b3f48&lang=less&scoped=true"

import exportComponent from "D:\\workday\\code\\h5-moxigecash\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a11b3f48"]])

export default __exports__